<template>
  <div class="pc-player">
    <video-player
      @ready="onReady"
      :playerOptions="playerOptions"
      v-show="isReady"
    ></video-player>

    <deeplink-btn
      class="pc-player-deeplink"
      ref="deeplinkBtn"
      :useFunc="data.more.use_func"
      :id="data.id"
      @wakeup="
        reportClick({
          click: 'use',
        })
      "
    ></deeplink-btn>

    <img class="pc-player-thumbnail" v-show="!isReady" :src="data._poster_url" />

    <template v-if="isReady">
      <div
        class="pc-player-poster-title ellipsis-2"
        ref="videoPosterTitle"
        v-show="showPosterTitle"
        v-html="$xss(data._poster_title)">
      </div>
    </template>

    <template v-if="isReady">
      <icon
        ref="videoPlayButton"
        class="pc-player-icon"
        v-show="playIconShow"
        @click="$emit('play-click')"
        type="iconic_play"
      ></icon>

      <icon
        ref="videoPauseButton"
        class="pc-player-icon"
        v-show="pauseIconShow"
        @click="$emit('pause-click')"
        type="iconic_pause"
      ></icon>
    </template>

    <!-- 有无评价收集 -->
    <video-feedback
      ref="videoFeedback"
      :show="usefulTipShow"
      :isFullScreen="isFullScreen"
      :id="data.id"
      :series="data.subject_id"
      :player="player"
      :reportShow="reportUsefulTipShow"
      :reportClick="reportUsefulTipClick"
      @useful-click="handleUsefulClick"
    ></video-feedback>
    <!-- End 有无评价收集 -->

    <!-- 无声自动播放提示 -->
    <video-muted
      ref="videoMuted"
      :show="mutedNoticeShow"
      :isFullScreen="isFullScreen"
      :player="player"
    ></video-muted>
    <!-- End 无声自动播放提示 -->

    <video-notplay-helper class="pc-player-notplay-helper" v-show="notplayHelperShow"/>

  </div>
</template>

<script>
import VideoPlayer from './video-player';
import VideoFeedback from './video-feedback';
import VideoMuted from './video-muted';
import DeeplinkBtn from './deeplink-btn';

import VIDEO_LANGUAGE from '@/common/constant/video-language';
import VideoNotplayHelper from './video-notplay-helper.vue';

export default {
  data() {
    return {
      isReady: false,
      player: null,
      showPosterTitle: true
    };
  },

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },

    pauseIconShow: Boolean,
    playIconShow: Boolean,
    notplayHelperShow: Boolean,
    usefulTipShow: Boolean,
    mutedNoticeShow: Boolean,
    reportUsefulTipShow: Function,
    reportUsefulTipClick: Function,
    reportClick: Function,
    reportShow: Function,
    isFullScreen: Boolean,
    videoWrapper: {
      type: Object,
      default: () => ({
        width: '924px',
        height: '520px'
      })
    }
  },

  computed: {
    // videojs的播放器配置
    playerOptions() {
      const { data } = this;
      if (!data) return {};

      return {
        // videojs options
        controls: true,
        autoplay: false,
        preload: 'none',
        disablePictureInPicture: true,
        playbackRates: [0.5, 1, 1.5, 2],
        width: `${this.videoWrapper.width}px`,
        height: `${this.videoWrapper.height}px`,
        sources: [
          {
            type: 'video/mp4',
            src: data.post_video.url,
          },
        ],
        poster: data._poster_url, //封面图
        languages: VIDEO_LANGUAGE,
        controlBar: {
          // 设置控制条组件
          // currentTimeDisplay: true,
          // timeDivider: true,
          // durationDisplay: true,
          // remainingTimeDisplay: false,
          // customControlSpacer: true,

          /* 使用children的形式可以控制每一个控件的位置，以及显示与否 */
          children: [
            { name: 'playToggle' }, // 播放按钮
            { name: 'currentTimeDisplay' }, // 当前已播放时间
            { name: 'timeDivider' }, // 时间分割线
            { name: 'durationDisplay' }, // 总时间
            { name: 'progressControl' }, // 播放进度条

            {
              // 倍数播放
              name: 'playbackRateMenuButton',
              playbackRates: [0.5, 1, 1.5, 2],
            },
            {
              name: 'volumePanel', // 音量控制
              inline: false, // 不使用水平方式
            },
            { name: 'FullscreenToggle' }, // 全屏
          ],
        },
        _poster_title: data._poster_title // 新增视频封面图上文字
      };
    },
  },

  components: {
    VideoPlayer,
    VideoFeedback,
    VideoMuted,
    DeeplinkBtn,
    VideoNotplayHelper,
  },

  methods: {
    handleVideoPlay() {
      this.showPosterTitle = false;
      if (this._isShowDeeplink) return;

      // 10秒后展示deeplink
      this._isShowDeeplink = true;
      setTimeout(() => {
        this.$refs.deeplinkBtn.handleShow();
        this.reportShow({ show: 'use' });
      }, 10000);
    },

    onReady(player) {
      this.isReady = true;
      this.$emit('ready', player);
      this.setVideoDuration();

      player.on('play', () => this.handleVideoPlay());
      this.player = player;
    },

    setVideoDuration() {
      const videoDuration = Math.floor(+this.data.post_video?.time) || 0;

      const minute = Math.floor(videoDuration / 60);
      const second = videoDuration % 60;
      const videoSecond = second >= 10 ? second : `0${second}`;

      const videoTime = `${minute}:${videoSecond}`;

      let videoTimeDisplay = document.querySelector('.vjs-duration-display');

      //端内浏览器加载机制问题，会出现被innertxt后的文字被二次覆盖的情况，此处用settimeout处理确保innerText正确赋值
      setTimeout(() => {
        if (videoTimeDisplay && videoTimeDisplay.firstChild) {
          videoTimeDisplay.firstChild.nodeValue = videoTime;
        }
      }, 200);
    },

    handleUsefulClick(val) {
      this.$emit('useful-click', val);
    }
  },
};
</script>

<style lang="scss" scoped>
.pc-player {
  position: relative;
  height: 520px;
  &-thumbnail {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 1;
  }

  &-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 69px;
    cursor: pointer;
    z-index: 6;
  }

  &-notplay-helper {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
    z-index: 6;
  }

  &-deeplink {
    position: absolute !important;
    bottom: 65px;
    right: 30px;
  }

  ::v-deep {
    // 屏蔽videoJS插件自带的失焦交互
    .vjs-control-bar  {
      opacity: 1 !important;
      z-index: 4;
    }

    .vjs-hidden {
      display: none !important;
    }
  }

  .pc-player-poster-title {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-53%, -65%);
    z-index: 1;
    line-height: 104px;
    color: white;
    font-weight: bold;
    user-select: none;
    width: 717px;
    font-size: 70px;
  }
  svg.pc-player-icon {
    top: auto;
    left: 20px;
    bottom: 60px;
    transform: none;
  }
}
</style>
